import { call, put, takeLatest, select } from 'redux-saga/effects';
import pickBy from 'lodash/pickBy';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { getSortParams } from '../helpers/utils';
import { SET_LOADER } from '../redux/Loader';
import { ADS } from '../consts/navigation';
import { FETCH_ADS, FETCH_ADS_FAIL, FETCH_ADS_SUCCESS } from '../redux/Ads';

function* FetchAdsFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', ADS, 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', ADS, 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', ADS, 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', ADS, 'page']));
    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/ads`;
    const myBets = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_ADS_SUCCESS(myBets));
  } catch (error) {
    yield put(FETCH_ADS_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchAds() {
  yield takeLatest(FETCH_ADS, FetchAdsFlow);
}
